'use strict';
const angular = require('angular');

export class piperUpcomingGuestsWidgetComponent {

  constructor(Auth, PiperListService) {
    'ngInject';
    this.PiperListService = PiperListService;
    this.Auth = Auth;
  }

  $onInit() {
    let limit = this.count || 3;
    this.PiperListService.getByHostAndType({
      hostid: this.Auth.getCurrentUserSync()._id,
      type: 'temporary'
    }, (data) => {
      this.data = data.slice(0,limit);
    });
  }
}

export default angular.module('conduuApp.piperUpcomingGuests', [])
  .component('piperUpcomingGuestsWidget', {
    template: require('./piper-upcoming-guests-widget.component.html'),
    bindings: {
      count: '@'
    },
    controller: piperUpcomingGuestsWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/piper-upcoming-guests-widget/piper-upcoming-guests-widget.component.js